<template>
  <div class="table-wrapper">
    <div class="table-header">
      <div class="table__search-input-wrapper">
        <input
          type="text"
          class="table__search-input"
          placeholder="Search..."
          v-model="queryString"
        />
        <svg
          width="18"
          height="18"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9 0C13.9706 0 18 4.02944 18 9C18 11.1248 17.2637 13.0776 16.0323 14.6172L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3466 20.0676 18.7794 20.0953 18.3871 19.7903L18.2929 19.7071L14.6172 16.0323C13.0776 17.2637 11.1248 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0ZM9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2Z"
            fill="#060f18"
          />
        </svg>
      </div>
      <div class="table__btn-wrapper">
        <router-link to="/settings/users-and-groups/new-group">
          <button class="bg-secondary-orange table__btn">
            New Group
          </button>
        </router-link>
      </div>
    </div>

    <table class="custom-table responsive-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Function</th>
          <th>Permission</th>
          <th>Date Added</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="filteredGroupMembers">
        <tr v-if="!loading && filteredGroupMembers.length == 0">
          <td></td>
          <td></td>
          <td>
            <p>No group members found!</p>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr v-if="loading">
          <td></td>
          <td></td>
          <td><loader /></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr v-for="member in filteredGroupMembers" :key="member.id">
          <td>{{ member.firstName }} {{ member.lastName }}</td>
          <td>{{ member.workEmail }}</td>
          <td>-</td>
          <td>{{ member.roles }}</td>
          <td v-if="member.updatedAt">{{ member.updatedAt | formatDate }}</td>
          <td
            tabindex="-1"
            @blur="selectedRowId = null"
            class="table__action-btn cursor-pointer"
          >
            <span @click="showActionOptions(member.id)">
              <vertical-ellipsis />
            </span>
            <div
              class="table__action-options"
              @blur="logBlur"
              v-if="selectedRowId == member.id"
            >
              <div
                class="table__action-option cursor-pointer"
                @click="makeUserGroupAdmin(member.id)"
              >
                <p>Make Admin</p>
              </div>
              <div
                class="table__action-option cursor-pointer"
                @click="removeUserFromGroup(member.id)"
              >
                <p>Remove</p>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <pagination />
    <delete-modal
      :showModal="isDeleteModal"
      @close-modal="isDeleteModal = false"
      itemToDelete="User"
      :deletingItem="deletingItem"
      @delete-item="removeUserFromGroup"
    />
  </div>
</template>

<script>
import Pagination from "@/components/UI/pagination";
import DeleteModal from "@/components/UI/Modal/DeleteModal";
export default {
  components: {
    Pagination,
    DeleteModal,
  },
  props: ["groupMembers", "loading"],
  data() {
    return {
      selectedRowId: null,
      isDeleteModal: false,
      deletingItem: false,
      queryString: "",
    };
  },
  computed: {
    filteredGroupMembers() {
      return this.filterArray(this.groupMembers, this.queryString);
    },
  },
  methods: {
    async makeUserGroupAdmin(userId) {
      this.generateToast("Processing...", "success");
      try {
        let response = await this.$_makeUserGroupAdmin(userId);
        console.log(response);
        this.generateToast("User has been made an admin!", "success");
        this.$emit("update");
      } catch (error) {
        this.handleError(error);
      }
    },
    async removeUserFromGroup(userId) {
      this.generateToast("Processing...", "success");
      try {
        let response = await this.$_removeUserFromGroup(userId);
        console.log(response);
        this.generateToast("User has been removed!", "success");
        this.$emit("update");
        this.$store.dispatch("resetAllGroups");
      } catch (error) {
        this.handleError(error);
      }
    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    showDeleteModal() {
      this.$emit("show-delete-modal");
      this.resetSelectedRow();
    },
    showViewRoleModal() {
      this.$emit("show-view-role-modal");
      this.resetSelectedRow();
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
    logBlur() {
      console.log("blurred");
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  margin: 3rem 0;
}
.table-header {
  display: flex;
  justify-content: flex-end;
}
.custom-select {
  width: 20vw;
}
.table__btn {
  padding: 0.45rem 0.85rem;
  color: #ffffff;
  font-size: 0.85rem;
  border-radius: 3px;
}
.table__search-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 30vw;
  border-radius: 15px;
  padding: 0 1rem;
  margin-right: 1.5rem;
}
.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}
.table__search-input:focus {
  outline: none;
}
.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}
.custom-table {
  margin: 2rem 0;
  width: 100%;
}
.custom-table tr {
  border-bottom: 1px solid #d5d5d5;
}
.custom-table th {
  color: #060e18;
  font-weight: 600;
}
.custom-table th,
td {
  padding: 1rem;
  font-size: 0.9rem;
}
.custom-table td {
  color: #343633;
}
.table__action-btn {
  position: relative;
  padding: 0;
}
.table__action-options {
  position: absolute;
  width: 8rem;
  padding: 0.5rem 0;
  /* height: 7rem; */
  right: 2rem;
  background: #ffffff;
  z-index: 999;
  border-radius: 3px;
  box-shadow: 0px 0px 12px #dee0e7;
}
.table__action-option {
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
}
.table__action-option:hover {
  background: #fce4da;
}
.table__action-btn span {
  width: 100%;
}
</style>
